// extracted by mini-css-extract-plugin
export default {"page":"Lycvb","header":"cDP8V","inner":"ZOPvO","actionCell":"Rg6t6","downloadIcon":"U0Apq","emptyText":"XtI1i","filtersAndDownload":"Bgcv_","headerText":"bqhNF","text":"twLNj"};